import { render, staticRenderFns } from "./activityFeedItem.vue?vue&type=template&id=5342adca&scoped=true"
import script from "./activityFeedItem.vue?vue&type=script&lang=js"
export * from "./activityFeedItem.vue?vue&type=script&lang=js"
import style0 from "./activityFeedItem.vue?vue&type=style&index=0&id=5342adca&prod&scoped=true&lang=css"
import style1 from "./activityFeedItem.vue?vue&type=style&index=1&id=5342adca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342adca",
  null
  
)

export default component.exports